<template>
  <div class="fr-hero">
    <div class="page-help content">
      <h1>{{ $t("newFranchise.heroTitle") }}</h1>
      <p>{{ $t("newFranchise.heroTxt1") }}</p>
      <p>{{ $t("newFranchise.heroTxt2") }}</p>
      <div class="wrapp-card">
        <div v-for="(card, index) in cards" :key="index" class="cardF">
          <img :src="card.img" alt="" />
          <h3 class="title">{{ $t(card.title) }}</h3>
          <div class="text-card">
            {{ $t(card.text) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import card_franchise1 from "@/assets/newImges/card_franchise1.svg";
import card_franchise2 from "@/assets/newImges/card_franchise2.svg";
import card_franchise3 from "@/assets/newImges/card_franchise3.svg";
export default {
  data() {
    return {
      cards: [
        {
          img: card_franchise1,
          title: "newFranchise.heroCardTitle1",
          text: "newFranchise.heroCardTxt1"
        },
        {
          img: card_franchise2,
          title: "newFranchise.heroCardTitle2",
          text: "newFranchise.heroCardTxt2"
        },
        {
          img: card_franchise3,
          title: "newFranchise.heroCardTitle3",
          text: "newFranchise.heroCardTxt3"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.fr-hero {
  width: 100%;
  font-family: Outfit;
  text-align: left;
  padding-top: 118px;
  background-image: url("../../assets/newImges/EllipseRight.png") !important;
  background-repeat: no-repeat;
  background-position: right bottom;

  .content {
    h1 {
      font-weight: 700;
      font-style: Bold;
      font-size: 79px;
      line-height: 108px;
      letter-spacing: 0%;
      margin: 0;
      margin-bottom: 24px;
    }
    p {
      font-weight: 500;
      font-style: Medium;
      font-size: 24px;
      line-height: 35px;
      letter-spacing: 0%;
      max-width: 1009px;
    }
  }
  .wrapp-card {
    margin-top: 120px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 19px;
    .cardF {
      box-sizing: border-box;
      padding: 28px;
      width: 31%;
      background-color: $gray-blue-400;
      border: 1px solid $gray-blue-500;
      border-radius: 12px;
      gap: 32px;
      color: $blue-1000;
      transition: 0.3s;

      h3 {
        font-weight: 400;
        font-style: Regular;
        font-size: 25px;
        line-height: 24px;
        letter-spacing: 0%;
        width: 100%;
      }
      .text-card {
        font-weight: 400;
        font-style: Regular;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
      }
    }
    .card:hover {
      transform: scale(1.06);
    }
  }
}
@media only screen and (max-width: 750px) {
  .fr-hero {
    padding-top: 60px;

    .content {
      h1 {
        font-size: 39px;
        line-height: 58px;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        line-height: 25px;
      }
    }
    .wrapp-card {
      margin-top: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 19px;
      .cardF {
        box-sizing: border-box;
        padding: 28px;
        width: 80%;
        background-color: $gray-blue-400;
        border: 1px solid $gray-blue-500;
        gap: 32px;
        margin-bottom: 30px;
        margin-right: 0;

        h3 {
          font-size: 25px;
          line-height: 24px;
        }
        .text-card {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
